module.exports = __webpack_public_path__ + "static/media/blackHole.18277caf.mp3";